import {Resource} from "../../api/resource";
import {BasicEntity, BasicProperty} from "../../basic-entity-back/annotations";
import {PropertyType} from "../../basic-entity-back/property-type/property-type";
import {PropertyMap, ReadWrite} from "../../basic-entity-back/basic-entity-interface/mapping-external";
import {Archivo} from "./archivo.model";

@BasicEntity({
    name: 'Archivo HTML',
    endpoint: 'archivo_blender_h_t_m_ls',
    isPaginated: true,
    paginationSizes: [20, 30, 50],
    type: "ArchivoBlenderHTML"
})
export class ArchivoBlenderHTML extends Archivo {
    public static readonly BLENDER_MAP: PropertyMap = {
        name: 'Blender',
        type: PropertyType.FutureUri('blender.model.ts'),
        readWrite: ReadWrite.ReadOnly
    }
    @BasicProperty(ArchivoBlenderHTML.BLENDER_MAP)
    private _blender;

    get blender() {
        return this._blender;
    }

    set blender(value) {
        this._blender = value;
    }
}
